import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import AntAvatar from 'antd/lib/avatar';
import './style';

const propTypes = {
  className: PropTypes.string,
  decorated: PropTypes.bool,
  size: PropTypes.oneOf(['small', undefined, 'default', 'large', 'hero']),
  shape: PropTypes.oneOf(['square', 'circle']),
  ...AntAvatar.propTypes,
};

const defaultProps = {
  decorated: false,
  size: 'default',
  shape: 'circle',
  ...AntAvatar.defaultProps,
};

function Avatar({ className, decorated, size, shape, ...rest }) { // eslint-disable-line
  const computedClassName = classNames(
    'bsa-avatar',
    className,
    { 'bsa-avatar--hero': size === 'hero' },
    { 'bsa-avatar--square': shape === 'square' && size === 'hero' },
  );
  const Component = (<AntAvatar
    className={computedClassName}
    size={size}
    shape={shape}
    {...rest}
  />);
  if (decorated) {
    const wrapperClasses = classNames(
      'bsa-avatar__wrapper',
      {
        'bsa-avatar--square': shape === 'square',
      },
    );
    const decorationClasses = classNames(
      'bsa-avatar__decoration',
      {
        'bsa-avatar--square': shape === 'square',
      },
    );
    return (
      <div className={wrapperClasses}>
        <div className={decorationClasses}>
          {Component}
        </div>
      </div>);
  }
  return Component;
}

Avatar.defaultProps = defaultProps;
Avatar.propTypes = propTypes;
export default Avatar;
